var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 75,
  height: 75,
  viewBox: "0 0 75 75"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 75,
  fill: "none"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 37.5,
  r: 37.5,
  fill: "#d75a4a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,43.137,29.569,29.569,43.137,16",
  transform: "translate(7.931 7.931)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,16,29.569,29.569,43.137,43.137",
  transform: "translate(7.931 7.931)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}))));
export default __webpack_public_path__ + "static/media/paymentfailed.8d20e835.svg";
export { SvgComponent as ReactComponent };